import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'
const StoreRepository = RepositoryFactory.get('store')

const SET_LOADING = 'SET_LOADING'
const SET_INVOICES = 'SET_INVOICES'

export default {
  namespaced: true,
  state: {
    invoices: [],
    loading: false,
  },
  getters: {
    invoices: (state) => state.invoices,
    loading: (state) => state.loading,
  },
  mutations: {
    [SET_INVOICES]: (state, invoices) => (state.invoices = invoices),
    [SET_LOADING]: (state, loading) => (state.loading = loading),
  },
  actions: {
    fetchInvoices({ rootState, commit }) {
      commit(SET_LOADING, true)
      StoreRepository.getStoreInvoices(rootState.user.token, rootState.shop.shop.id)
        .then(({ data }) => {
          commit(SET_INVOICES, data)
        })
        .catch((_) => {
          // swallow
        })
        .finally(() => {
          commit(SET_LOADING, false)
        })
    },
  },
}
